module.exports = __webpack_public_path__ + "img/benefit3.56b60651.svg";